// Configuration de l'API Backend
const getBaseUrl = () => {
  const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:8080';

  // Si l'URL se termine déjà par /api/v1, la retourner telle quelle
  if (apiUrl.endsWith('/api/v1')) {
    return apiUrl;
  }

  // Sinon, ajouter /api/v1 à la fin (en enlevant le slash final si présent)
  const cleanUrl = apiUrl.replace(/\/$/, '');
  return `${cleanUrl}/api/v1`;
};

export const API_CONFIG = {
  BASE_URL: getBaseUrl(),
  TIMEOUT: 30000, // 30 secondes
  HEADERS: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
};

// Endpoints de l'API
export const API_ENDPOINTS = {
  // Authentication
  AUTH: {
    REGISTER: '/auth/register',
    LOGIN: '/auth/login',
    REFRESH: '/auth/refresh',
    LOGOUT: '/auth/logout',
    CHANGE_PASSWORD: '/auth/change-password',
  },

  // Users
  USERS: {
    ME: '/users/me',
    UPDATE_ME: '/users/me',
    CHANGE_PASSWORD: '/users/me/password',
    STATS: '/users/me/stats',
    LIST: '/users',
    BY_ID: (id) => `/users/${id}`,
    UPDATE_ROLE: (id) => `/users/${id}/role`,
    UPDATE_STATUS: (id) => `/users/${id}/status`,
  },

  // Archives
  ARCHIVES: {
    LIST: '/archives',
    BY_ID: (id) => `/archives/${id}`,
    CREATE: '/archives',
    UPDATE: (id) => `/archives/${id}`,
    DELETE: (id) => `/archives/${id}`,
    PUBLISH: (id) => `/archives/${id}/publish`,
    ARCHIVE: (id) => `/archives/${id}/archive`,
    SEARCH: '/archives/search',
    MY_ARCHIVES: '/archives/my',
    BY_CATEGORY: (id) => `/archives/category/${id}`,
  },

  // Categories (deprecated - use Commissions instead)
  CATEGORIES: {
    LIST: '/categories',
    ACTIVE: '/categories/active',
    BY_ID: (id) => `/categories/${id}`,
    CREATE: '/categories',
    UPDATE: (id) => `/categories/${id}`,
    DELETE: (id) => `/categories/${id}`,
    ARCHIVES: (id) => `/categories/${id}/archives`,
  },

  // Commissions (replaces Categories)
  COMMISSIONS: {
    LIST: '/commissions',
    ACTIVE: '/commissions/active',
    BY_ID: (id) => `/commissions/${id}`,
    CREATE: '/commissions',
    UPDATE: (id) => `/commissions/${id}`,
    DELETE: (id) => `/commissions/${id}`,
    SEARCH: '/commissions/search',
    MEMBERS: (id) => `/commissions/${id}/members`,
    ADD_MEMBER: (id) => `/commissions/${id}/members`,
    REMOVE_MEMBER: (commissionId, memberId) => `/commissions/${commissionId}/members/${memberId}`,
    UPDATE_MEMBER_ROLE: (commissionId, memberId) => `/commissions/${commissionId}/members/${memberId}/role`,
    ARCHIVES: (id) => `/commissions/${id}/archives`,
  },

  // Folders (Sous-dossiers dans les commissions)
  FOLDERS: {
    // Récupérer tous les dossiers d'une commission
    BY_COMMISSION: (commissionId) => `/commissions/${commissionId}/folders`,
    // Créer un dossier dans une commission
    CREATE: (commissionId) => `/commissions/${commissionId}/folders`,
    // Récupérer un dossier par ID
    BY_ID: (commissionId, folderId) => `/commissions/${commissionId}/folders/${folderId}`,
    // Mettre à jour un dossier
    UPDATE: (commissionId, folderId) => `/commissions/${commissionId}/folders/${folderId}`,
    // Supprimer un dossier
    DELETE: (commissionId, folderId) => `/commissions/${commissionId}/folders/${folderId}`,
    // Assigner une archive à un dossier
    ASSIGN_ARCHIVE: (commissionId, folderId) => `/commissions/${commissionId}/folders/${folderId}/archives`,
    // Retirer une archive d'un dossier
    REMOVE_ARCHIVE: (commissionId, folderId, archiveId) => `/commissions/${commissionId}/folders/${folderId}/archives/${archiveId}`,
    // Récupérer les archives d'un dossier
    ARCHIVES: (commissionId, folderId) => `/commissions/${commissionId}/folders/${folderId}/archives`,
  },

  // Viewed Items (Éléments déjà vus par l'utilisateur)
  VIEWED_ITEMS: {
    // Récupérer les commissions déjà vues
    COMMISSIONS: '/users/me/viewed/commissions',
    // Marquer une commission comme vue
    MARK_COMMISSION: (commissionId) => `/users/me/viewed/commissions/${commissionId}`,
    // Récupérer les sous-dossiers déjà vus
    FOLDERS: '/users/me/viewed/folders',
    // Marquer un sous-dossier comme vu
    MARK_FOLDER: (commissionId, folderId) => `/users/me/viewed/commissions/${commissionId}/folders/${folderId}`,
    // Réinitialiser toutes les vues
    RESET: '/users/me/viewed',
  },
};

// Codes d'erreur
export const ERROR_CODES = {
  INVALID_CREDENTIALS: 'INVALID_CREDENTIALS',
  TOKEN_EXPIRED: 'TOKEN_EXPIRED',
  INVALID_TOKEN: 'INVALID_TOKEN',
  ACCESS_DENIED: 'ACCESS_DENIED',
  VALIDATION_ERROR: 'VALIDATION_ERROR',
  USER_NOT_FOUND: 'USER_NOT_FOUND',
  ARCHIVE_NOT_FOUND: 'ARCHIVE_NOT_FOUND',
  CATEGORY_NOT_FOUND: 'CATEGORY_NOT_FOUND',
};
